import React from 'react'

import { useAnalysisTypes } from 'redux/hooks/AnalysisTypes'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Chip from 'components_new/atoms/Chip'
import LinearProgress from 'components_new/atoms/LinearProgress'

import ContentBox from 'components_new/molecules/ContentBox'
import StatusBox from 'components_new/molecules/StatusBox'

import AnalysisTypesOverviewTable from 'components_new/organisms/analysis_types/AnalysisTypesOverviewTable'
import HeadlineMetricPreview from 'components_new/organisms/HeadlineMetricPreview'

import PageLayout from 'components_new/templates/PageLayout'

import { getFollowedAnalysisTypes } from 'utils/analysis'

const Results = () => {
  const { t } = useTranslation()

  const {
    analysisTypes,
    error: analysesError,
    loading: analysesLoading
  } = useAnalysisTypes()

  const activeAnalysisTypes = getFollowedAnalysisTypes(analysisTypes)
  const inactiveCount = analysisTypes.length - activeAnalysisTypes.length

  return (
    <PageLayout
      content={{
        fullWidth: true
      }}
      topbar={{
        breadcrumbs: [
          { icon: { name: 'Results' }, title: t('global', 'results') }
        ]
      }}
      variant="feed"
    >
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          gap: 2,
          minWidth: 0
        }}
      >
        <HeadlineMetricPreview />
        <ContentBox
          border={true}
          header={
            1 !== 1
              ? {
                  size: 'medium',
                  title: t('analyses', 'analyses'),
                  titleAdornment:
                    analysesLoading || analysesError ? undefined : (
                      <Chip label={activeAnalysisTypes.length} size="small" />
                    )
                }
              : null
          }
        >
          <AnalysisTypesOverviewTable />
        </ContentBox>

        {inactiveCount > 0 ? (
          <StatusBox severity="info" title={t('analysis_types', 'promo_title')}>
            {t('analysis_types', 'promo_body', false, {
              count: String(inactiveCount)
            })}
            <LinearProgress
              customLabel={`${activeAnalysisTypes.length} / ${analysisTypes.length}`}
              label={true}
              sx={{ mb: 1 }}
              value={(activeAnalysisTypes.length / analysisTypes.length) * 100}
              variant="determinate"
            />
            <Button href="/analysis-types">
              {t('analysis_types', 'view_all_analysis_types')}
            </Button>
          </StatusBox>
        ) : null}
      </Box>
    </PageLayout>
  )
}

export default Results
